export const HOME_PAGE_ROUTER_PATH = '/';

export const RESUME_LANDING_ROUTER_PATH = '/jianli/';

export const JOB_TITLE_PAGE_ROUTER_PATH = '/job-titles/';

export const JOB_DETAIL_PAGE_ROUTER_PATH = '/job-detail/';

export const JOB_RANKING_PAGE_ROUTER_PATH = '/rank/';

export const RANK_TOP_SALARY_PAGE_ROUTER_PATH = '/topsalary/';

export const RANK_TOP_POST_PAGE_ROUTER_PATH = '/toppost/';

export const CULTURAL_ROUTER_PATH = '/wenhua/';

export const CULTURAL_ALL_TYPE_ROUTER_PATH = '/wenhua/result/all';

export const CULTURAL_QUIZ_ROUTER_PATH = '/wenhua/quiz/';

export const CULTURAL_RESULT_ROUTER_PATH = '/wenhua/result/';

export const COMPANY_ROUTER_PATH = '/companies/';

export const CANDIDATES_ME_ROUTER_PATH = '/jianli/me/';

export const DEFAULT_CANDIDATES_ME_ROUTER_PATH = '/jianli/me/default/';

export const RESUME_CONSULTATION_ROUTER_PATH = '/jianli/service/';

export const RESUME_CONSULTATION_ORDER_ROUTER_PATH = '/jianli/service-order/';

export const RESUME_EVALUATION_ROUTER_PATH = '/jianli/evaluation/';

export const RESUME_EVALUATION_LOADING_ROUTER_PATH =
  '/jianli/evaluation/loading/';

export const RESUME_EVALUATION_ME_ROUTER_PATH = '/jianli/evaluation/me/';

export const JOB_SALARY_INSIGHT_ROUTER_PATH = '/job-salary-insight/';

export const ARTICLES_ROUTER_PATH = '/articles/';

export const TERMS_ROUTER_PATH = '/terms/';

export const PRIVACY_ROUTER_PATH = '/privacy/';

export const LOGIN_ROUTER_PATH = '/login/';

export const SUBSCRIBE_ROUTER_PATH = '/subscribe/';

export const RECORD_URL = 'https://beian.miit.gov.cn/';

export const PRODUCTION_URL = 'https://www.tanzhi.cn';

export const PRODUCTION_HOST = 'www.tanzhi.cn';

export const PRODUCTION_ENVIRONMENT = 'production';

/**
 * sitemap url
 */
export const SITEMAP_ROUTER_PATH = '/sitemap/';
export const SITEMAP_JOB_TITLE_ROUTER_PATH = `${SITEMAP_ROUTER_PATH}job-title/`;
export const SITEMAP_JOB_TITLE_CITY_ROUTER_PATH = `${SITEMAP_ROUTER_PATH}job-title-city/`;
export const SITEMAP_JOB_RANKING_ROUTER_PATH = `${SITEMAP_ROUTER_PATH}jobranking/`;
export const SITEMAP_JOB_RANKING_CITY_ROUTER_PATH = `${SITEMAP_ROUTER_PATH}jobranking-city/`;
export const SITEMAP_CITY_ROUTER_PATH = `${SITEMAP_ROUTER_PATH}city/`;
export const SITEMAP_COMPANY_ROUTER_PATH = `${SITEMAP_ROUTER_PATH}company/`;
export const SITEMAP_ARTICLE_ROUTER_PATH = `${SITEMAP_ROUTER_PATH}article/`;
